import React from "react";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";

import { PlanItem } from "./plan-item";
import { usePlansPage } from "./use-plans-page";
import { GiftButton } from "../../../components/gift/giftButton";
import { GiftCelebrationDialog } from "../../../components/gift/GiftCelebrationDialog";
import { useGiftCelebration } from "../../../components/gift/use-gift-celebration";
import { SimpleSnackbar } from "../../../components/snackbar";
import PageTitle from "../../../components/PageTitle";
import PageHeading from "../../../components/ui/PageHeading";

export const PlansPage: React.FC = () => {
  const {
    user,
    loading,
    displayedPlans,
    dueDate,
    planInVerification,
    preapprovalId,
    isPlanCancelled,
    hasGift,
    giftData,
    activateUserGift,
    showSnackbar,
    snackbarMessage,
    setShowSnackbar,
    handlePlanSelected,
    handleOneTimePurchase,
    handleChangeCard,
    cancelPlanPreapproval,
  } = usePlansPage();

  const { celebrationOpen, openCelebration, closeCelebration } = useGiftCelebration(hasGift, giftData?.plan);

  return (
    <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
      <PageTitle title="Planos" />

      <SimpleSnackbar show={showSnackbar} message={snackbarMessage} onDismiss={() => setShowSnackbar(false)} />

      <GiftButton hasGift={hasGift} onActivateGift={openCelebration} />

      <GiftCelebrationDialog
        open={celebrationOpen}
        planName={giftData?.plan}
        onActivate={() => activateUserGift(user.email)}
        onClose={closeCelebration}
      />

      <Box sx={{ textAlign: "center", mb: 4 }}>
        <PageHeading align="center" sx={{ mb: 1 }}>
          Escolha o plano ideal para você
        </PageHeading>
        <Typography sx={{ fontSize: "0.9375rem", color: "text.secondary" }}>
          Mais tempo cuidando dos pacientes, menos tempo formulando.
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: 2.5, alignItems: "stretch", maxWidth: 980, mx: "auto" }}>
          {displayedPlans.map((plan) => (
            <PlanItem
              key={plan.id}
              plan={plan}
              dueDatePlan={dueDate || 0}
              planInCheck={planInVerification}
              userHasPlan={user.planId !== undefined && user.planId !== null}
              isActualPlan={user.planId === plan.id}
              onPlanSelected={() => handlePlanSelected(plan)}
              onOneTimePurchase={() => handleOneTimePurchase(plan)}
              onChangeCard={() => handleChangeCard(plan)}
              onCancelPlan={() => cancelPlanPreapproval(preapprovalId as string)}
              isPreapproval={!!(plan.preapproval_enabled && preapprovalId != null && preapprovalId !== "")}
              isPlanCancelled={isPlanCancelled}
              isPromotional={!!plan.is_promotional}
              isPlanPreapproval={!!plan.preapproval_enabled}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
